import { FileTextOutlined } from '@ant-design/icons';
import { Row, Space, message, notification } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';

import { Button, Modal } from '../../../../components/index';
import { RangePickerStylized } from '../../../../components/common/datepicker/styles';
import { useExportOmittedXmlMutation } from '../../../../services/omissionApi';

type ModalExportOmissionXmlProps = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  // Período já filtrado na tela, usado como valor inicial do modal.
  initialDate?: string;
  finalDate?: string;
};

export function ModalExportOmissionXml(props: ModalExportOmissionXmlProps) {
  const { showModal, setShowModal, initialDate, finalDate } = props;

  const [dates, setDates] = useState<
    [moment.Moment | null, moment.Moment | null] | null
  >(null);

  const [exportOmittedXml, { isLoading: isLoadingExportXml }] =
    useExportOmittedXmlMutation();

  useEffect(() => {
    if (showModal) {
      setDates([
        initialDate ? moment(initialDate) : null,
        finalDate ? moment(finalDate) : null,
      ]);
    }
  }, [showModal, initialDate, finalDate]);

  function handleCloseModal() {
    setDates(null);
    setShowModal(false);
  }

  async function handleExportXml() {
    const initial = dates?.[0];
    const final = dates?.[1];

    if (!initial || !final) {
      notification.warning({
        message: 'Informe o período do relatório',
        placement: 'top',
        duration: 3,
      });
      return;
    }

    try {
      // O endpoint apenas aceita a solicitação: o arquivo não vem na resposta.
      await exportOmittedXml({
        initial_date_report: initial.format('YYYY-MM-DD'),
        final_date_report: final.format('YYYY-MM-DD'),
      }).unwrap();

      message.success(
        'XML em processamento. Você o receberá em seu e-mail em breve.',
        5
      );
      handleCloseModal();
    } catch (error) {
      message.error('Erro ao gerar XML. Tente novamente.');
    }
  }

  return (
    <Modal
      visible={showModal}
      className="TOSPrimaryModal"
      width={520}
      title="Gerar relatório XML"
      onCancel={() => handleCloseModal()}
      footer={null}
    >
      <>
        <p>
          Selecione o período das omissões que deseja exportar. O XML é gerado
          em segundo plano e enviado para o seu e-mail.
        </p>
        <Row>
          <div style={{ width: '100%' }}>
            <div style={{ marginBottom: '4px' }}>Período do relatório</div>
            <RangePickerStylized
              allowClear
              value={dates}
              onChange={(value) =>
                setDates(
                  value as [moment.Moment | null, moment.Moment | null] | null
                )
              }
              minuteStep={1}
              showTime={false}
              format={['DD/MM/YYYY', 'DD/MM/YYYY']}
              placeholder={['Data inicial', 'Data final']}
              style={{ width: '100%', background: 'var(--neutral_lightest)' }}
            />
          </div>
        </Row>
        <br />
        <Row justify="end">
          <Space size={12}>
            <Button
              onClick={() => handleCloseModal()}
              disabled={isLoadingExportXml}
            >
              Voltar
            </Button>
            <Button
              type="primary"
              icon={<FileTextOutlined />}
              loading={isLoadingExportXml}
              onClick={() => handleExportXml()}
            >
              Gerar XML
            </Button>
          </Space>
        </Row>
      </>
    </Modal>
  );
}
